// MT-015: mismo criterio que el servidor (web/src/api/lib/nacimiento-representante.ts).
/** Misma constante que el servidor (api/lib/nacimiento-representante.ts): menores de esta edad firman con representante legal (LOPDP art. 21 y 24). */
export const EDAD_REPRESENTANTE_OBLIGATORIO = 15;

export function edadEnAnios(birthDate: string, hoy: Date = new Date()): number | null {
  const m = /^(\d{4})-(\d{2})-(\d{2})$/.exec(birthDate.trim());
  if (!m) return null;
  const [y, mo, d] = [Number(m[1]), Number(m[2]), Number(m[3])];
  let edad = hoy.getFullYear() - y;
  if (hoy.getMonth() + 1 < mo || (hoy.getMonth() + 1 === mo && hoy.getDate() < d)) edad -= 1;
  return edad;
}

/** 15 a 17 anios cumplidos: consiente el propio adolescente (sin representante). */
export function esAdolescenteQueConsiente(birthDate: string, hoy: Date = new Date()): boolean {
  const e = edadEnAnios(birthDate, hoy);
  return e !== null && e >= EDAD_REPRESENTANTE_OBLIGATORIO && e < 18;
}

export function esMenorDeEdad(birthDate: string, hoy: Date = new Date()): boolean {
  const m = /^(\d{4})-(\d{2})-(\d{2})$/.exec(birthDate.trim());
  if (!m) return false;
  const [y, mo, d] = [Number(m[1]), Number(m[2]), Number(m[3])];
  let edad = hoy.getFullYear() - y;
  if (hoy.getMonth() + 1 < mo || (hoy.getMonth() + 1 === mo && hoy.getDate() < d)) edad -= 1;
  return edad >= 0 && edad < EDAD_REPRESENTANTE_OBLIGATORIO;
}

export function hoyISO(hoy: Date = new Date()): string {
  const p = (n: number) => String(n).padStart(2, '0');
  return `${hoy.getFullYear()}-${p(hoy.getMonth() + 1)}-${p(hoy.getDate())}`;
}
